import { render, staticRenderFns } from "./TalkAskOpinion.vue?vue&type=template&id=78791dd8&scoped=true&"
import script from "./TalkAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./TalkAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./TalkAskOpinion.vue?vue&type=style&index=0&id=78791dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78791dd8",
  null
  
)

export default component.exports